function setSchedulers(data) {
	return {
		type: 'SET_SCHEDULERS',
		payload: data,
	};
}

export { setSchedulers };
